<div class="app-container custom-mat-override">
  <div class="app-header">
    <app-header></app-header>
  </div>

  <div class="app-content">


    <div class="app-main">
    @if(isLogin){
      <app-side-bar></app-side-bar>
      } @else { 
      <div class="height-300">
      </div>
    }
      <!-- <router-outlet></router-outlet> -->
    </div>

    <div class="app-footer">
      <app-footer></app-footer>
    </div>
  </div>
</div>
<app-loader></app-loader>
